export default "__VITE_ASSET__BkNT59oh__"